import { Link } from 'react-router-dom';
import { customerCases } from '@/mocks/home';

function CustomerCases() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-8 lg:px-12 bg-background-100 overflow-hidden">
      {/* Subtle decorative */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/3 right-0 w-[500px] h-[500px] rounded-full bg-secondary-500/[0.015] blur-[130px]" />
      </div>

      <div className="max-w-7xl mx-auto relative">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 md:mb-20 gap-4">
          <div>
            <span className="inline-block px-4 py-1.5 mb-5 text-xs font-medium text-secondary-600 bg-secondary-100 rounded-full">
              客户实证
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 mb-3 tracking-tight">
              政企优选 · 信赖之选
            </h2>
            <p className="text-sm text-foreground-500">覆盖政企、高校、外贸、自媒体等全行业应用</p>
          </div>
          <Link
            to="/support/cases"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer group"
          >
            查看全部案例
            <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform inline-block"></i>
          </Link>
        </div>

        {/* 4-column case cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 mb-12">
          {customerCases.map((item) => (
            <div
              key={item.id}
              className="group bg-white rounded-2xl border border-background-200 p-5 md:p-6 hover:border-primary-200/70 transition-all duration-400 hover:-translate-y-1 hover:shadow-[0_8px_30px_-8px_rgba(0,0,0,0.05)] flex flex-col"
            >
              {/* Company header */}
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors duration-300 flex-shrink-0">
                  <span className="text-sm font-bold text-primary-600">{item.logo}</span>
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 truncate">{item.company}</div>
                  <span className="inline-block text-xs text-secondary-600 bg-secondary-50 px-2 py-0.5 rounded-full mt-0.5">
                    {item.category}
                  </span>
                </div>
              </div>

              {/* Scene */}
              <div className="mb-3">
                <span className="text-xs text-foreground-400 font-medium uppercase tracking-wide">合作场景</span>
                <div className="text-sm font-medium text-foreground-700 mt-1">{item.scene}</div>
              </div>

              {/* Product */}
              <div className="mb-3">
                <span className="text-xs text-foreground-400 font-medium uppercase tracking-wide">落地产品</span>
                <div className="text-sm text-foreground-600 mt-1 leading-snug">{item.product}</div>
              </div>

              {/* Description */}
              <p className="text-xs text-foreground-500 leading-relaxed mt-auto pt-2 border-t border-background-100">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom CTA bar */}
        <div className="bg-white rounded-2xl border border-background-200 p-6 md:p-8 flex flex-col sm:flex-row items-center justify-between gap-6 hover:border-primary-200/50 transition-all duration-400">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-accent-50 flex items-center justify-center flex-shrink-0">
              <i className="ri-star-fill text-xl text-accent-500"></i>
            </div>
            <div>
              <div className="text-lg font-bold text-foreground-900">政企优选 · 99% 客户满意度</div>
              <div className="text-sm text-foreground-500">累计服务 500+ 政企单位，覆盖 30+ 行业领域</div>
            </div>
          </div>
          <Link
            to="/contact"
            className="group inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-400 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-[0_4px_20px_rgba(0,0,0,0.1)]"
          >
            成为我们的客户
            <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform inline-block"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default CustomerCases;